const COMMON_PREFIX = 'window.__lq_'
// cookie前缀
// export const COOKIE_PREFIX = 'lq_'
export const COOKIE_PREFIX = ''
// 部门删除
export const DEPARTMENT_DELETE = COMMON_PREFIX + 'department.delqxRows'
export const SCRIPT_BASEURL = process.env.BASE_URL + '/scripts'
export const CSS_BASEURL = process.env.BASE_URL + '/css'
// 静态资源的url
export const RESOURCE_BASE_URL = 'https://t9bs.lqfast.com'
